var _path, _path2, _path3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSupportScratchWin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.01908 19.6472C2.99848 19.7041 2.99446 19.7657 3.00751 19.8248C3.02057 19.884 3.05014 19.9381 3.09275 19.9809C3.13537 20.0236 3.18924 20.0533 3.24805 20.0663C3.30685 20.0793 3.36812 20.0751 3.42465 20.0543C4.44835 19.6765 6.95645 18.3685 11.7417 13.8469C16.8062 9.05828 18.3151 5.93741 18.7437 4.73458C18.7638 4.6778 18.7674 4.61643 18.7541 4.55765C18.7408 4.49887 18.7112 4.44511 18.6687 4.40263C18.6262 4.36014 18.5725 4.3307 18.514 4.31774C18.4554 4.30477 18.3944 4.30882 18.3381 4.32941C17.3148 4.70724 14.8067 6.01521 10.0214 10.5369C4.95541 15.3239 3.44801 18.4448 3.01908 19.6472Z",
    fill: "url(#paint0_linear_6578_38539)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.24673 13.4963C3.84361 13.2445 5.307 12.3734 8.09896 9.35755C11.0544 6.16558 11.9336 4.08464 12.1838 3.28308C12.1955 3.24524 12.1977 3.20433 12.1899 3.16513C12.1822 3.12594 12.165 3.09007 12.1402 3.06172C12.1154 3.03337 12.0841 3.0137 12.05 3.00501C12.0159 2.99632 11.9803 2.99897 11.9474 3.01265C11.3502 3.26397 9.88679 4.13669 7.09518 7.15176C4.13976 10.3433 3.26017 12.4243 3.01038 13.2275C2.99885 13.2652 2.99688 13.306 3.0047 13.345C3.01253 13.384 3.02982 13.4196 3.05457 13.4478C3.07933 13.4759 3.11053 13.4954 3.14454 13.504C3.17855 13.5126 3.21399 13.5099 3.24673 13.4963Z",
    fill: "url(#paint1_linear_6578_38539)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.896 21.1046C10.8842 21.1424 10.8821 21.1833 10.8898 21.2225C10.8975 21.2617 10.9148 21.2975 10.9395 21.3259C10.9643 21.3542 10.9956 21.3739 11.0297 21.3826C11.0639 21.3913 11.0994 21.3886 11.1323 21.375C11.7295 21.1229 13.1928 20.2511 15.9843 17.2364C18.9396 14.0453 19.8191 11.9646 20.0689 11.1615C20.0807 11.1237 20.0829 11.0828 20.0752 11.0436C20.0675 11.0044 20.0503 10.9685 20.0255 10.9401C20.0007 10.9118 19.9693 10.8922 19.9352 10.8836C19.901 10.875 19.8654 10.8777 19.8326 10.8915C19.2357 11.1432 17.7724 12.0154 14.9806 15.0297C12.0253 18.2224 11.1461 20.3031 10.896 21.1046Z",
    fill: "url(#paint2_linear_6578_38539)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6578_38539",
    x1: 5.61194,
    y1: 10.5542,
    x2: 21.8832,
    y2: 23.3795,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CBB48E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#FBE7C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CBB48E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_6578_38539",
    x1: 4.52363,
    y1: 7.16261,
    x2: 14.9518,
    y2: 14.3548,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CBB48E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#FBE7C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CBB48E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_6578_38539",
    x1: 12.4089,
    y1: 15.0413,
    x2: 22.8371,
    y2: 22.2335,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CBB48E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#FBE7C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CBB48E"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupportScratchWin);
export default __webpack_public_path__ + "static/media/supportScratchWin.6f688e4e00bccc11fffe40bc17c15fb0.svg";
export { ForwardRef as ReactComponent };